"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ONE_YEAR_IN_MINUTES = exports.CONSENT_COOKIE = void 0;
var _utils = require("@whitbread-eos/utils");
var CONSENT_COOKIE = exports.CONSENT_COOKIE = 'consent_cookie';
var ONE_YEAR_IN_MINUTES = exports.ONE_YEAR_IN_MINUTES = 60 * 24 * (0, _utils.getNoOfDaysInYear)(new Date().getFullYear());